<template>
  <section :class="['popup-wrapper', fissionGame]">
    <van-popup
      v-model="show"
      class="activity-fission-popup"
      :style="{ height: isTurbo ? '100%' : '85%' }"
      position="bottom"
      round
      :overlay-style="{ background: 'rgba(0,0,0, 0.9)' }"
    >
      <div
        class="close-wrapper"
        @click="showSwitch"
        :style="{ background: 'rgba(0,0,0,0)' }"
      >
        <span class="iconfont icon-cancel"></span>
      </div>
      <section class="popup-body">
        <activity-home
          type="popup"
          displayMode="fullscreen"
          :game="gameName"
          @click-share="clickShare"
          :showShareBtn="false"
          ref="activityPage"
          @first-share-status="getFirstShareStatus"
          :popupOpenType="popupOpenType"
        />
      </section>
    </van-popup>
    <div class="shareBtn-wrapper" v-if="show">
      <share-btn
        @click-share="clickShare"
        hasTips
        :firstShareStatus="firstShareFinished"
        :btnText="$t('fission.share-one')"
        couponType="1"
        registerAwardsType="1"
      />
    </div>
    <!-- 分享面板  -->
    <share-popup
      ref="sharePopup"
      page="fission"
      :activitySource="activitySource"
    />
  </section>
</template>
<script>
  import { mapState } from 'vuex'
  import ActivityHome from './index'
  import SharePopup from '../components/SharePopup'
  import { ShareBtn } from '../components/CommonBtns/index.js'
  import { share_show } from '../firebase'
  import { getQuery } from '@/utils/utils'
  import { pagePopupShow } from '@/pages/marketingFirebase.js'

  export default {
    components: {
      ActivityHome,
      SharePopup,
      ShareBtn,
    },
    props: {
      popupOpenType: {
        default: '',
        type: String,
      },
      gameName: {
        default: '',
        type: String,
      },
      activityId: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        show: false,
        firstShareFinished: false,
        activitySource: getQuery('activitySource') || getQuery('source'), //活动生效渠道
      }
    },
    watch: {
      show(val) {
        val ? this.$emit('opened') : this.$emit('closed')
        if (val) {
          // 裂变大弹窗曝光
          pagePopupShow({
            page: this.gameName || 'home',
            list_id: '',
            act_id: this.activityId, // 活动编号
            popup_type: 'popup',
          })
        }
      },
    },
    computed: {
      ...mapState(['fissionGame', 'isTurbo']),
    },
    methods: {
      showSwitch() {
        this.show = !this.show
      },
      clickShare() {
        share_show({ form: this.popupOpenType })
        this.$refs.sharePopup && this.$refs.sharePopup.switch()
      },
      getFirstShareStatus(status) {
        this.firstShareFinished = status
      },
    },
  }
</script>

<style lang="scss" scoped>
  .popup-wrapper {
    .shareBtn-wrapper {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 3000;
      width: 100%;
      height: 410px;
      background: linear-gradient(
        180deg,
        rgba(14, 29, 71, 0) 0%,
        rgba(14, 29, 71, 0.641951) 28.27%,
        #0e1d47 100%
      );
      padding-top: 50px;
      box-sizing: border-box;
      ::v-deep .common-btn-wrapper {
        height: 176px;
      }
    }
    .share-btn-wrapper {
      z-index: 3000 !important;
    }
    .activity-fission-popup {
      background-color: transparent;
      .popup-body {
        background: #313e63;
        position: relative;
        overflow: hidden;
        border-radius: 60px 60px 0px 0px;
        box-sizing: border-box;
      }
      .close-wrapper {
        height: 92px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        // margin-top: 18px;
        position: sticky;
        left: 0;
        top: 0;
        z-index: 999;
        .iconfont {
          color: #666;
          font-size: 120px;
        }
      }
    }
    &.pubgm {
      .shareBtn-wrapper {
        background: linear-gradient(
          180deg,
          rgba(21, 32, 42, 0) 0%,
          #15202a 43.89%,
          #21282e 100%
        );
      }
      .activity-fission-popup {
        .popup-body {
          background: rgba(33, 40, 46, 1);
        }
      }
    }
    &.genshin {
      .shareBtn-wrapper {
        background: linear-gradient(
          180deg,
          rgba(96, 105, 134, 0) 0%,
          rgba(96, 115, 134, 0.8) 43.89%,
          #606986 100%
        );
      }
      .activity-fission-popup {
        .popup-body {
          background: rgba(127, 135, 161, 1);
        }
      }
    }
  }
</style>
